export const PLAN_MODEL_KEYS = new Set(['payAsYouGo', 'subscription']);

const CAD_ONLY_PERMISSIONS = new Set([
  'InteracMoneyRequestEnabled',
  'InteracBulkPayoutEnabled',
  'InboundEtransferEnabled',
  'PushToCardEnabled',
]);

export function isPermissionAllowedForCurrency(permissionKey: string, currency: string): boolean {
  // USD-only rails.
  if (/^USDEFT(Collect|Send)Enabled$/.test(permissionKey)) return currency === 'USD';
  // CAD-only rails — unavailable on USD packages.
  if (/^EFT(Collect|Send)Enabled$/.test(permissionKey) || CAD_ONLY_PERMISSIONS.has(permissionKey)) {
    return currency !== 'USD';
  }
  return true;
}

// True when a plan-setting section should be rendered for the given currency: either it has no
// permission toggles (fee-only section) or at least one of its permissions is allowed for the
// currency. Sections whose permissions are all currency-disallowed are hidden entirely so their
// fees are never shown, validated, or submitted.
export function sectionHasCurrencyAllowedPermission(permissions: Record<string, unknown>, currency: string): boolean {
  const permKeys = Object.keys(permissions).filter((key) => !PLAN_MODEL_KEYS.has(key));
  return permKeys.length === 0 || permKeys.some((key) => isPermissionAllowedForCurrency(key, currency));
}

// On a USD package the EFT rails run on the USDEFT permission (no separate matrix entry),
// so label them "USD EFT …". No-op for non-USD packages and non-EFT rails.
export function railDisplayLabel(displayName: string, currency: string): string {
  return currency === 'USD' && /^EFT\b/.test(displayName) ? `USD ${displayName}` : displayName;
}

export function formatKey(key: string): string {
  const knownWords = ['EFT', 'ACH', 'IQ11', 'iQ11', 'eLinx', 'USDEFT'];

  for (const word of knownWords) {
    key = key.replace(new RegExp(word, 'g'), `|${word}|`);
  }

  const parts = key.split('|').flatMap((part) => part.match(/[A-Z]?[a-z]+|[A-Z]+(?![a-z])|\d+/g) ?? []);

  return parts.filter(Boolean).join(' ');
}
